module.exports = __webpack_public_path__ + "img/proud_hl.61d09776.svg";